<template>
    <div class="report-export" v-cloak id="report-export">
        <div class="reportExportMain">


          <div class="reportExportDom" id="pdfDom">
						<!-- 背景图 -->
						<div class="setBackground" :style="{'background-image': `url('${ backgroundImg }')`}"></div>
          	<div class="reportCanvas"></div>
            <div class="reportExportBox">

								<!-- LOGO / TITLE -->
                <div class="reportTitle">
									<div style="display: flex; justify-content: left;">
										<!--  :style="{'background-image': `url('${ logoUrl }')`}" -->
										<div class="LOGO">
											<img :src="logoUrl" alt="">
										</div>
										<div class="LOGO" style="margin-left: 0; color: #FFF; border: none;">
											<p style="text-align: center;">严肃性考试服务专家</p>
											<p style="text-align: center;">smart.chinaedu.net</p>
										</div>
										<span style="color: #FFF; float: right; opacity: .4; user-select: none;" v-if="false">#{{PDFInfo.timestamp}}</span>
									</div>
                  <div class="analysisScope">
										<strong>{{PDFInfo.planName}} 考试分析报告</strong>
									</div>
									
									<div class="ImgCode" :style="{'background-image': `url('${ weChatImg }')`}"></div>
                </div>

								<!-- TItle（考试概况） -->
								<div class="viewReportBox_Title">
                  <div class="viewReportTit"><span class="title_Left"></span><span>考试概况</span></div>
								</div>

								<!-- 地图 -->
                <div class="viewReportBox">
									<div class="viewReportBar" style="width: 544px;">
										<div class="Bar_item">
											<p><strong>{{PDFInfo.examDay}}</strong>天</p>
											<p>考试周期</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.cityCount}}</strong>个</p>
											<p>考试城市</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.placeCount}}</strong>个</p>
											<p>考点</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.examStuCount}}</strong></p>
											<p>考生</p>
										</div>
									</div>
                  <div class="viewReportMa">
                    <el-row :gutter="20" class="Chart_A_Box">
											<div class="Chart_A" id="Chart_A"></div>
                    </el-row>						
										<div class="countBox">
											<div class="title" style="width: 72px;">
												<span>报告说明：</span>
											</div>
											<div class="content" style="width: 950px;">
												<p>
													<!-- 为期{{PDFInfo.examDay}}天 -->
													<span>{{PDFInfo.planName}}考试已于{{PDFInfo.beginExam}}至{{PDFInfo.endExam}}顺利结束。</span>
													<span>本次考试分布在{{PDFInfo.cityName}}{{PDFInfo.cityCount}}个城市，设置{{PDFInfo.placeCount}}个考点。</span>
													<span>共有{{PDFInfo.examStuCount}}考生参加本次考试。</span>
												</p>
												<div class="content_time">
													<p>
														<span>报名时间：{{PDFInfo.beginSign}}—{{PDFInfo.endSign}}</span>
														<span>考试时间：{{PDFInfo.beginExam}}—{{PDFInfo.endExam}}</span>
														<span v-if="PDFInfo.isReview == 1">阅卷时间：{{PDFInfo.teacherReviewBeginTime}} — {{PDFInfo.teacherReviewEndTime}}</span>
													</p>
												</div>
											</div>
                    </div>
                  </div>
                </div>

								<!-- Title（报名缴费） -->
								<div class="viewReportBox_Title">
                  <div class="viewReportTit"><span class="title_Left"></span><span>报名缴费</span></div>
								</div>

								<!-- 报名情况 -->
                <div class="viewReportBox">
									<div class="viewReportTit_2"><span>报名情况</span></div>
									<div class="viewReportBar" style="width: 860px;">
										<div class="Bar_item" v-if="PDFInfo.preSignCount != 0">
											<p><strong>{{PDFInfo.preSignCount}}</strong>人</p>
											<p>预报名</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.signCount}}</strong>人</p>
											<p>实际报名</p>
										</div>
										<div class="Bar_item" v-if="PDFInfo.signPercent != 0">
											<p><strong>{{PDFInfo.signPercent}}</strong>%</p>
											<p>报考率</p>
										</div>
										<div class="Bar_item" v-if="PDFInfo.photoVerifyOncePassPercent != 0">
											<p><strong>{{PDFInfo.photoVerifyOncePassPercent}}</strong>%</p>
											<p>人证核验一次通过率</p>
										</div>
										<div class="Bar_item" v-if="PDFInfo.photoStandardCount != 0">
											<p><strong>{{PDFInfo.photoStandardCount}}</strong>人次</p>
											<p>使用智能证件照</p>
										</div>
										<div class="Bar_item" v-if="PDFInfo.photoStandardPercent != 0">
											<p><strong>{{PDFInfo.photoStandardPercent}}</strong>%</p>
											<p>智能证件照使用率</p>
										</div>
									</div>
                  <div class="viewReportMa">
										<div class="Chart_B_Border">
											<div class="Chart_B_1 item">
												<div class="title">报名终端统计</div>
												<div class="chart" id="Chart_B_1" style="border-left: 0px;"></div>
												<div class="desc">
													<div>
														<span class="icon"></span>
														<span class="info">手机端报名：{{PDFInfo.mobileSignCount}}人</span>
													</div>
													<div>
														<span class="icon" style="background: linear-gradient(180deg, #FFB588 0%, #FA7922 100%)"></span>
														<span class="info">PC端报名：{{PDFInfo.webSignCount}}人</span>
													</div>
												</div>
											</div>
											<div class="Chart_B_2 item" v-show="PDFInfo.photoStandardCount">
												<div class="title">智能证件照使用率</div>
												<div class="chart" id="Chart_B_2"></div>
												<div class="desc">
													<div>
														<span class="icon"></span>
														<span class="info">使用智能证件照：{{PDFInfo.photoStandardCount}}人</span>
													</div>
												</div>
											</div>
											<div class="Chart_B_2 item" v-show="Math.ceil(PDFInfo.photoVerifyOncePassPercent * PDFInfo.signCount * 0.01) > 0">
												<div class="title">人证核验一次通过率</div>
												<div class="chart" id="Chart_B_3"></div>
												<div class="desc">
													<div>
														<span class="icon"></span>
														<span class="info">人证核验一次通过：{{Math.ceil(PDFInfo.photoVerifyOncePassPercent * PDFInfo.signCount * 0.01)}}人</span>
													</div>
												</div>									
											</div>
										</div>
										<div style="width: 1008px; height: 291px; margin-top: 54px;">
											<span style="margin-left: 24px; font-size: 16px;">报名人数分布图</span>
											<div class="Chart_B_right" id="Chart_Sign" style="width: 1008px; height: 291px;"></div>
										</div>
									</div>
						
									<div class="viewReportMa" style="margin-top: 40px;">
										<div class="countBox">
											<div class="title">
												<span>【图表解读】</span>
											</div>
											<div class="content">
												<p>
													<span v-if="PDFInfo.preSignCount != 0">本次考试预报名人数为 {{PDFInfo.preSignCount}} 人，</span>
													<span>实际报名人数为 {{PDFInfo.signCount}} 人，</span>
													<span v-if="PDFInfo.signPercent != 0">报考率为 {{PDFInfo.signPercent}}%。</span>
													<span v-if="PDFInfo.photoStandardCount > 0">其中，有 {{PDFInfo.photoStandardCount}} 人次使用慧考平台智能证件照转换功能，占比 {{PDFInfo.photoStandardPercent}}%。</span>
													<span v-if="PDFInfo.photoVerifyOncePassPercent > 0">公安机关人证核验一次通过率 {{PDFInfo.photoVerifyOncePassPercent}}%。 </span>
													<span>本次考试移动端报名人数占比 {{ (PDFInfo.mobileSignCount/(PDFInfo.mobileSignCount + PDFInfo.webSignCount) * 100).toFixed(2) }}%，</span>
													<span>Web端报名人数占比{{( PDFInfo.webSignCount/(PDFInfo.mobileSignCount + PDFInfo.webSignCount) * 100).toFixed(2) }}%。</span>
												</p>
											</div>
										</div>
									</div>

                </div>

								<!-- 审核情况  -->
								<div class="viewReportBox" v-if="PDFInfo.isAudit == 1">
									<div class="viewReportTit_2"><span>审核情况</span></div>
									<div class="viewReportBar" style="width: 860px;">
										<div class="Bar_item">
											<p><strong>{{PDFInfo.auditOncePassCount}}</strong>人</p>
											<p>一次审核通过</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.auditOncePassPercent}}</strong>%</p>
											<p>一次审核通过率</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.auditAverageTime}}</strong>分钟</p>
											<p>平均审核时长</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.auditPassCount}}</strong>人</p>
											<p>审核通过人数</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.auditNoPassCount}}</strong>人</p>
											<p>审核不通过</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.auditPassPercent}}</strong>%</p>
											<p>总通过率</p>
										</div>
									</div>

									<div class="viewReportMa">
										<div class="Chart_B_Border" style="justify-content: space-around; margin-top: 0;">
											<div class="Chart_B_1 item" style="width: 420px; height: 270px;">
												<div class="chart" id="Chart_B_4" style="width: 420px; height: 270px; border-right: none;"></div>
												<div class="desc">
													<div>
														<span class="icon"></span>
														<span class="info">一次审核通过：{{PDFInfo.auditOncePassCount}}人</span>
													</div>
													<div>
														<span class="icon" style="background: linear-gradient(180deg, #FFB588 0%, #FA7922 100%)"></span>
														<span class="info">一次审核不通过：{{ Math.ceil(PDFInfo.auditOncePassCount/(PDFInfo.auditOncePassPercent * 0.01) - PDFInfo.auditOncePassCount) }}人</span>
													</div>
												</div>
											</div>
											<div class="Chart_B_2 item" style="width: 420px; height: 270px;">
												<div class="chart" id="Chart_B_5" style="width: 420px; height: 270px; border-right: none;"></div>
												<div class="desc">
													<div>
														<span class="icon"></span>
														<span class="info">终审通过：{{PDFInfo.auditPassCount}}人</span>
													</div>
													<div>
														<span class="icon" style="background: linear-gradient(180deg, #FFB588 0%, #FA7922 100%)"></span>
														<span class="info">终审不通过：{{PDFInfo.auditNoPassCount}}人</span>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div class="viewReportMa" style="margin-top: 60px;">
										<div class="countBox">
											<div class="title">
												<span>【图表解读】</span>
											</div>
											<div class="content">
												<p>
													<span>本次考试审核通过 {{PDFInfo.auditPassCount}} 人</span>
													<span>，一次审核通过人数为：{{PDFInfo.auditOncePassCount}} 人，</span>
													<span v-if="PDFInfo.auditNoPassCount > 0">审核不通过 {{PDFInfo.auditNoPassCount}} 人</span>
													<span v-else>无审核不通过人数</span>
													<span>。一次审核通过率为 {{PDFInfo.auditOncePassPercent}}%，审核通过率为 {{PDFInfo.auditPassPercent}}%，平均审核时间为 {{PDFInfo.auditAverageTime}} 分钟，</span>
													<span>约 {{PDFInfo.auditAverageTimePercent}}% 考生数据在 {{PDFInfo.auditAverageTime}} 分钟（平均审核时间）内审核完成。</span>
												</p>
											</div>
										</div>
									</div>
								</div>

								<!-- 缴费情况  -->
								<div class="viewReportBox" v-if="PDFInfo.isPay == 1">
									<div class="viewReportTit_2"><span>缴费情况</span></div>
									<div class="viewReportBar" style="width: 396px;">
										<div class="Bar_item">
											<p><strong>{{PDFInfo.unPayCount + PDFInfo.payCount}}</strong>人</p>
											<p>应缴费人数</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.payCount}}</strong>人</p>
											<p>实缴费人数</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.payPercent}}</strong>%</p>
											<p>缴费率</p>
										</div>
									</div>
									<div class="viewReportMa">
										<div class="Chart_B_Border" style="justify-content: space-around; margin-top: 0;">
											<div class="Chart_B_1 item" style="width: 420px; height: 270px;">
												<div class="chart" id="Chart_B_6" style="width: 420px; height: 270px; border-right: none;"></div>
												<div class="desc">
													<div>
														<span class="icon" style="background: linear-gradient(180deg, #5DC9FF 0%, #0077FF 100%)"></span>
														<span class="info">已缴费：{{PDFInfo.payCount}}人</span>
													</div>
													<div>
														<span class="icon" style="background: linear-gradient(180deg, #FFB588 0%, #FA7922 100%)"></span>
														<span class="info">未缴费：{{PDFInfo.unPayCount}}人</span>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="viewReportMa" style="margin-top: 60px;">
										<div class="countBox">
											<div class="title">
												<span>【图表解读】</span>
											</div>
											<div class="content">
												<p>
													<span>本次考试审核通过的 {{PDFInfo.auditPassCount}} 名考生中有 {{PDFInfo.payCount}} 名考生完成缴费，缴费率 {{PDFInfo.payPercent}}%</span>
												</p>
											</div>
										</div>
									</div>
								</div>

								<!-- 考试情况 -->
								<div class="viewReportBox_Title">
                  <div class="viewReportTit"><span class="title_Left"></span><span>考试情况</span></div>
								</div>

								<!-- 考试整体情况 -->
								<div class="viewReportBox">
									<div class="viewReportTit_2"><span>考试整体情况</span></div>
									<div class="viewReportBar" style="width: 1008px;">
										<div class="Bar_item">
											<p><strong>{{PDFInfo.payCourseCount}}</strong>人次</p>
											<p>应考</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.examCount}}</strong>人次</p>
											<p>实考</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.unExamCount}}</strong>人次</p>
											<p>缺考</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.unusualCount}}</strong>人次</p>
											<p>违纪</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.examPercent}}</strong>%</p>
											<p>参考率</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.unExamPercent}}</strong>%</p>
											<p>缺考率</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.unusualPercent}}</strong>%</p>
											<p>违纪率</p>
										</div>
									</div>
                  <div class="viewReportMa">
										<div class="table_A" style="margin-top: 24px;">
											<ots-table-new :tableHeader="tableHeader_A" :tableData="tableData_A"></ots-table-new>
										</div>
									</div>
									<div class="viewReportMa" style="margin-top: 40px;">
										<div class="countBox">
											<div class="title">
												<span>【图表解读】</span>
											</div>
											<div class="content">
												<p>
													<span>本次考试应考人次 {{PDFInfo.payCourseCount}}，实考人次 {{PDFInfo.examCount}}，缺考人次 {{PDFInfo.unExamCount}}，违纪人次 {{PDFInfo.unusualCount}}。</span>
													<span>综合计算，参考率 {{PDFInfo.examPercent}}%，缺考率 {{PDFInfo.unExamPercent}}%，违纪率 {{PDFInfo.unusualPercent}}%。</span>
												</p>
											</div>
										</div>
									</div>
								</div>

								<!-- 考试并发情况分布 -->
								<div class="viewReportBox" v-show="PDFInfo.loginMaxCount">
									<div class="viewReportTit_2"><span>考试并发情况分布</span></div>
									<div class="viewReportBar" style="width: 318px;">
										<div class="Bar_item">
											<p><strong>{{PDFInfo.loginMaxCount}}</strong></p>
											<p>进场并发最高数</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.submitMaxCount}}</strong></p>
											<p>交卷并发最高数</p>
										</div>
									</div>
									<div class="Chart_G_Box" v-if="tableData_A.length > 2">
										<div class="Chart_G" id="Concurrency"></div>
										<div class="Concurrency"><span>多场考试最高并发数</span></div>
									</div>
									<div class="Chart_G_Box" v-else>
										<div class="Chart_G" id="Concurrency_line"></div>
										<div class="Concurrency"><span>单场考试进场/交卷人数趋势图</span></div>
									</div>
									<div class="viewReportMa" style="margin-top: 40px;">
										<div class="countBox">
											<div class="title">
												<span>【图表解读】</span>
											</div>
											<div class="content">
												<p>
													<span>本次考试每分钟最高并发人数为 {{PDFInfo.loginMaxCount}} 人次，交卷最高并发人数为 {{PDFInfo.submitMaxCount}}人次，考生平均答卷时长为 {{PDFInfo.answerAverageTime}} 分钟。</span>
												</p>
											</div>
										</div>
									</div>

								</div>

								<!-- 监考工作 -->
								<div class="viewReportBox" v-if="isShowSign">
									<div class="viewReportTit_2"><span>监考工作</span></div>
									<div class="viewReportBar" style="width: 692px;" v-if="PDFInfo.signPassCount > 0 || PDFInfo.forceSubmitCount > 0 || PDFInfo.forceSubmitCount > 0">
										<div class="Bar_item">
											<p><strong>{{PDFInfo.signPassCount}}</strong>人次</p>
											<p>签到通过</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.signUnPassCount}}</strong>人次</p>
											<p>签到不通过</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.unSignCount}}</strong>人次</p>
											<p>未签到</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.forceSubmitCount}}</strong>人次</p>
											<p>强制交卷</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.addTimeCount}}</strong>人次</p>
											<p>补时</p>
										</div>
									</div>
									<div class="viewReportMa" v-show="PDFInfo.signPassCount > 0 || PDFInfo.forceSubmitCount > 0 || PDFInfo.forceSubmitCount > 0">
										<div class="Chart_E_Border">
											<div class="Chart_E" id="Chart_E"></div>
										</div>
                  </div>
									<div class="viewReportMa">
										<div class="countBox" style="margin-top: 0;">
											<div class="title" v-if="PDFInfo.signPassCount > 0 || PDFInfo.forceSubmitCount > 0 || PDFInfo.forceSubmitCount > 0">
												<span>【图表解读】</span>
											</div>
											<div class="content">
												<p>
													<span>本次考试期间，</span>
													<span v-if="PDFInfo.signPassCount > 0">有 {{PDFInfo.signPassCount}} 名考生签到通过。</span>
													<span v-if="PDFInfo.unSignCount > 0">{{PDFInfo.unSignCount}} 名考生未签到。</span>
													<span v-if="PDFInfo.signUnPassCount > 0">{{PDFInfo.signUnPassCount}} 名考生签到不通过。</span>
													<span v-if="PDFInfo.forceSubmitCount > 0">强制交卷处理 {{PDFInfo.forceSubmitCount}} 次。</span>
													<span v-if="PDFInfo.addTimeCount > 0">为 {{PDFInfo.addTimeCount}} 人次考生提供补时方案。</span>
												</p>
											</div>
										</div>
									</div>
								</div>

								<!-- TITLE（阅卷工作） -->
								<div class="viewReportBox_Title" v-show="PDFInfo.isReview == 1">
									<div class="viewReportTit"><span class="title_Left"></span><span>阅卷工作</span></div>
								</div>

								<!-- 阅卷分配 -->
								<div class="viewReportBox" v-show="PDFInfo.isReview == 1">
									<div class="viewReportTit_2"><span>阅卷分配</span></div>
									<div class="viewReportMa Grading_papers">
										<div class="Chart_B_Border">
											<div class="Chart_B_1 item" >
												<div class="chart" id="Chart_B_7"></div>
												<div class="desc">
													<div>
														<span class="icon" style="background: linear-gradient(180deg, #05C985 0%, #00B375 100%)"></span>
														<span class="info">实考已分配：{{PDFInfo.examAssignCount}}人</span>
													</div>
													<div>
														<span class="icon" style="background: linear-gradient(180deg, #FFB588 0%, #FA7922 100%)"></span>
														<span class="info">实考未分配：{{PDFInfo.examUnAssignCount}}人</span>
													</div>
												</div>
											</div>
											<div class="Chart_B_2 item" >
												<div class="chart" id="Chart_B_8"></div>
												<div class="desc">
													<div>
														<span class="icon" style="background: linear-gradient(180deg, #05C985 0%, #00B375 100%)"></span>
														<span class="info">已评阅：{{PDFInfo.reviewCount}}人</span>
													</div>
													<div>
														<span class="icon" style="background: linear-gradient(180deg, #FFB588 0%, #FA7922 100%)"></span>
														<span class="info">待评阅：{{PDFInfo.unReviewCount}}人</span>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="viewReportMa">
										<div class="countBox" style="margin-top: 0;">
											<div class="title">
												<span>阅卷分配说明：</span>
											</div>
											<div class="content">
												<p>阅卷时间范围：{{PDFInfo.teacherReviewBeginTime}} — {{PDFInfo.teacherReviewEndTime}}</p>
												<p>阅卷教师：{{PDFInfo.reviewTeacher}}</p>
											</div>
										</div>
									</div>
								</div>

								<!-- 各教师日评阅量统计 -->
								<div class="viewReportBox" v-show="PDFInfo.isReview == 1">
									<div class="viewReportTit_2"><span>各教师日评阅量统计</span></div>
									<div class="Chart_G_Box">
										<div class="Chart_G" id="Chart_G" style="height: 540px;"></div>
									</div>
									<div class="viewReportMa">
										<div class="countBox" style="margin-top: 20px;">
											<div class="title">
												<span>【图表解读】</span>
											</div>
											<div class="content">
												<p>本次考试共分配阅卷教师 {{PDFInfo.reviewTeacherCount}}名，评阅时间{{PDFInfo.reviewDay}}天，评阅教师日平均工作量为{{PDFInfo.averageReviewCount}}份/人。</p>
											</div>
										</div>
									</div>
								</div>

								<!-- 教师阅卷工作量 -->
								<div class="viewReportBox" v-show="PDFInfo.isReview == 1">
									<div class="viewReportTit_2"><span>教师阅卷工作量</span></div>
									<div class="viewReportBar" style="width: 692px;">
										<div class="Bar_item">
											<p><strong>{{PDFInfo.reviewTeacherCount}}</strong>人</p>
											<p>阅卷教师</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.reviewCourseCount}}</strong>门</p>
											<p>共需评阅课程</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.reviewTotal}}</strong>份</p>
											<p>共需评阅试卷</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.reviewCount}}</strong>份</p>
											<p>已评阅试卷</p>
										</div>
										<div class="Bar_item">
											<p><strong>{{PDFInfo.unReviewCount}}</strong>份</p>
											<p>未评阅试卷</p>
										</div>
									</div>
									<div class="Chart_G_Box">
										<div class="Chart_G" id="Chart_H"></div>
									</div>
									 <div class="viewReportMa">
										<div class="countBox" style="margin-top: 20px;">
											<div class="title">
												<span>【图表解读】</span>
											</div>
											<div class="content">
												<p>本次考试共有评阅教师 {{PDFInfo.reviewTeacherCount}}人，共需评阅课程 {{PDFInfo.reviewCourseCount}}门，试卷 {{PDFInfo.reviewTotal}}份，已评阅完成 {{PDFInfo.reviewCount}}份，剩余未评阅{{PDFInfo.unReviewCount}}份。</p>
											</div>
										</div>
									</div>
								</div>

								<!-- 各科主观题得分情况 -->
								<div class="viewReportBox" v-show="PDFInfo.isReview == 1 && isHasMedian">
									<div class="viewReportTit_2"><span>各科主观题得分情况</span></div>
									<div v-for="(item, key) in PDFInfo.reviewScoreList" :key="key" v-show="item.scoreMedian">
											<div class="viewReportBar" style="width: 396px;">
												<div class="Bar_item">
													<p><strong>{{item.courseName}}</strong></p>
													<p>科目</p>
												</div>
												<div class="Bar_item">
													<p><strong>{{item.totalScore}}</strong>分</p>
													<p>主观题总分</p>
												</div>
											</div>
											<div class="viewReportMa">
												<div class="Chart_G_Box">
													<div class="Chart_G" :id="'Chart_I'+key" v-show="item.teacherInfo.length > 0"></div>
												</div>
												<div class="countBox" style="margin-top: 20px;">
													<div class="title">
														<span>【图表解读】</span>
													</div>
													<div class="content">
														<p>本次考试 《{{item.courseName}}》 主观题总分 {{item.totalScore}} 分，考生成绩中位数为 {{item.scoreMedian}} 分。</p>
													</div>
												</div>
											</div>
									</div>
								</div>

								<!-- 考试成绩 -->
								<div class="viewReportBox_Title" v-show="PDFInfo.isScore == 1">
                  <div class="viewReportTit"><span class="title_Left"></span><span>考试成绩</span></div>
								</div>

								<!-- 成绩整体情况 -->
								<div class="viewReportBox" v-show="PDFInfo.isScore == 1">
									<div class="viewReportTit_2"><span>各科目成绩统计表</span></div>
									<div class="viewReportMa">
										<div class="table_A" style="margin-top: 24px;">
											<ots-table-new :tableHeader="tableHeader_score" :tableData="tableData_score"></ots-table-new>
										</div>
										<div class="countBox" style="margin-top: 20px;">
											<div class="title">
												<span>【图表解读】</span>
											</div>
											<div class="content">
												<p>
													<span>本次考试应考人数：{{PDFInfo.payCourseCount}}人，</span>
													<span>成绩合格人数：{{PDFInfo.scorePassCount}} 人，</span>
													<span>成绩不合格人数：{{PDFInfo.scoreNoPassCount}}人，申请成绩复查考生人数：{{PDFInfo.scoreReviewCount}}人，</span>
													<span>本次考试合格率{{PDFInfo.scorePassPercent}}%，优秀率{{PDFInfo.scoreExcellentPercent}}%。</span>
												</p>
											</div>
										</div>
									</div>
									<div class="viewReportTit_2" style="margin-top: 24px;"><span>正态分布图</span></div>
									<div class="viewReportMa" style="margin-top: 30px;">
										<div class="viewReportMa Chart_J" v-for="(item, key) in PDFInfo.analysInfo" :key="key">
											<div class="scoreNormalDistributionBox">
												<div class="chartItem scoreNormalDistribution" :id="'Chart_J'+key"></div>
												<div class="coefficientBox">
													<span>全距：<strong>{{item.fullRange}}</strong></span>
													<span>难度系数：<strong>{{item.difficultyCoefficient}}</strong></span>
													<span>区分度：<strong>{{item.discrimination}}</strong></span>
													<span>标准差：<strong>{{item.standardDeviation}}</strong></span>
													<span>变异系数：<strong>{{item.coefficientVariation}}</strong></span>
												</div>
											</div>					
											<div class="viewReportMa" style="margin-top: 80px;">
												<div class="interpret"><strong>【图像解读】</strong>{{item.analysisResult}}</div>
											</div>
										</div>
									</div>
								</div>

								<!-- TITLE(说明) -->
								<div class="viewReportBox_Title">
                  <div class="viewReportTit"><span class="title_Left"></span><span>报告说明</span></div>
								</div>

								<!-- 说明 -->
								<div class="viewReportBox">
                  <div class="viewReportMa" style="padding-bottom: 0;">
										<div class="countBox" style="margin: 0;">
											<p style="font-size: 16px; color: #2E3033; line-height: 30px;">
												本报告由弘成慧考平台于{{PDFInfo.reportCreateDate}}生成，所有数据结果为该时间之前的统计数据，在此时间之后数据将会根据实际情况发生改变，如要查看最新的考试报告数据请重新生成。
											</p>
                    </div>
                  </div>
                </div>

            </div>

            <div class="reportFooter">
              <p> 本次考试数据分析报告由 <strong> 弘成慧考平台 </strong> 提供数据分析服务</p>
            </div>

						<div class="waterView">
							<div class="waterItem" v-for="item in waterNumber" :key="item">
								<p>{{PDFInfo.timestamp}}</p>
							</div>
						</div>

          </div>

					<div class="reportOpt">
						<div class="reportOptMa">
							<div class="reportExport reportExportOpt" @click="handleExportPdf">导出分析报告</div>
						</div>
					</div>            

			</div>
    </div>
</template>

<script>
	import { exportPdfAPI, normalDataAllCourseAPI } from '@/http/modules/examReport'; 
  export default {
    name: "examReportPDF",
    data () {
      return {
				// initData 初始化数据
				backgroundImg: require("@/assets/img/newbackground.png"),
				defaultLogo: require("@/assets/img/customDefault.png"),
				weChatImg: require("@/assets/img/weChatQR.png"),
				systemInfo: {},
				logoUrl: '',
				// 考试概况
				tableHeader_A: [
					{
						title: "场次",
						prop: "sessionName",
					},
					{
						title: "应考人次",
						prop: "needExamCount",
					},
					{
						title: "考场数量",
						prop: "placeCount",
					},
					{
						title: "实考人次",
						prop: "examCount",
					},
					{
						title: "参考率",
						prop: "examPercent",
					},
				],
				tableData_A: [],
				tableHeader_B: [
					{
						title: "场次",
						prop: "session",
					},
					{
						title: "应考人次",
						prop: "session",
					},
					{
						title: "考场数量",
						prop: "session",
					},
					{
						title: "实考人次",
						prop: "session",
					},
					{
						title: "参考率",
						prop: "session",
					},
				],
				tableData_B: [],
				tableHeader_score: [
					{
						title: "科目",
						prop: "courseName",
					},
					{
						title: "合格",
						prop: "scorePassCount",
					},
					{
						title: "不合格",
						prop: "scoreNoPassCount",
					},
					{
						title: "优秀",
						prop: "scoreExcellentCount",
					},
					{
						title: "合计考试人数",
						prop: "examCount",
					},
					{
						title: "合格率",
						prop: "scorePassPercent",
					},
					{
						title: "优秀率",
						prop: "scoreExcellentPercent",
					},
				],
				tableData_score: [],
				PDFInfo: {},
				waterNumber: 0,
				// 是否显示"监考工作"
				isShowSign: false,
				//定时器
				timer1: '',
				timer2: '',
				// 页面标题名
				PDF_title: '',
				// 是否显示 "各科主观题得分情况"
				isHasMedian: false,
      }
    },

		created() {
			this.initData();
		},
		mounted() {
			this.getWaterView();
		},
		destroyed() {
			clearTimeout(this.timer1)
			clearTimeout(this.timer2)
		},

    methods : {
			// 水印高度
			getWaterView() {
				let that = this;
				this.timer1 = setTimeout(() => {
					let Height = document.getElementById("report-export").offsetHeight;
					that.waterNumber = Math.floor(Height/420) * 3;
				}, 2000);
			},

			// 数据初始化
			async initData() {
				// (1) Logo
				let param = { tenant: window.localStorage.getItem('tenant') };
				const { code, data: systemInfo } = await this.$api.system.getSystemNameFN(param);
				if (code === 1) this.systemInfo = systemInfo;
				this.logoUrl = systemInfo.isUsedLogo == 1 ? systemInfo.logoUrl ? systemInfo.logoUrl : this.defaultLogo: this.defaultLogo;
				let { tenantName } = systemInfo;
				// (2) 批次ID
				const { planId } = this.$route.query;
				// (3) PDF 整体数据
				const PDF = await exportPdfAPI({planId});
				if (PDF.code === 1) this.PDFInfo = PDF.data;

				// 交卷最高并发数
				if (this.PDFInfo.submitMaxCount === null) this.PDFInfo.submitMaxCount = 0;
				// 平均答卷时长
				if (this.PDFInfo.answerAverageTime == null) this.PDFInfo.answerAverageTime = 0;

				// (4) 地图数据
				var data = [];

				// (5) 地图散点图数据
				this.PDFInfo.citySiteList.map(e=>{
					e.value.map((v, i) => {
						let item = {
							name: e.name,
							value: [e.value[i].split(',')[1], e.value[i].split(',')[0]]
						}
						data.push(item);
					})						
				})
				this.PDFInfo.analysInfo = [];

				// (6) 正态分布数据
				let data_J = await normalDataAllCourseAPI({planId});
				if (data_J.code == 1) {
					data_J.data.map(e=>{
						if (e.scoreSection.length > 0) {
							this.PDFInfo.analysInfo.push(e);
						}
					})
				}

				// ** 绘制
				// (一) 考试概况
				this.tableData_A = this.PDFInfo.sessionList;
				this.tableData_A.map(e=>{ e.examPercent = e.examPercent + '%' });
				this.tableData_score = this.PDFInfo.courseScoreList;
				// (二) E-charts & Table
				// 地图
				await this.set_ChartA(data);
				// 报名终端统计 & 智能证件照使用率 & 人证核验一次通过率
				await this.set_Chart_Pie(this.PDFInfo.mobileSignCount, this.PDFInfo.webSignCount, 'Chart_B_1');
				await this.set_Chart_Pie(this.PDFInfo.photoStandardPercent, (100 - this.PDFInfo.photoStandardPercent), 'Chart_B_2');
				await this.set_Chart_Pie(this.PDFInfo.photoVerifyOncePassPercent, (100 - this.PDFInfo.photoVerifyOncePassPercent), 'Chart_B_3');
				// 报名人数分布图
				await this.set_Chart_Sign(this.PDFInfo.signDateList);
				// 审核
				if (this.PDFInfo.isAudit == 1) {
					await this.set_Chart_Pie(this.PDFInfo.auditOncePassCount, this.PDFInfo.auditOncePassCount/(this.PDFInfo.auditOncePassPercent * 0.01) - this.PDFInfo.auditOncePassCount, 'Chart_B_4');
					await this.set_Chart_Pie(this.PDFInfo.auditPassCount, this.PDFInfo.auditNoPassCount, 'Chart_B_5');
				}
				// 缴费
				if (this.PDFInfo.isPay) {
					await this.set_Chart_Pie(this.PDFInfo.payCount, this.PDFInfo.unPayCount, 'Chart_B_6');
				}
				// 并发
				if (this.PDFInfo.sessionList.length > 2) {
					await this.set_Concurrency(this.PDFInfo.concurrencyList);
				} else {
					await this.set_Concurrency_line(this.PDFInfo.concurrencyList);
				}

				// 签到
				if (!this.PDFInfo.signStateList) {
					this.PDFInfo.signDateList = [];
					this.isShowSign = false;
				} else {
					this.PDFInfo.signStateList.map(e=>{
						if (e.signPassCount > 0 || e.signUnPassCount > 0 || e.forceSubmitCount > 0 || this.PDFInfo.addTimeCount > 0) {
							this.isShowSign = true;
							return;
						}
					})
				}
				await this.set_ChartE(this.PDFInfo.signStateList, this.isShowSign);
				// 阅卷
				await this.set_Chart_Pie(this.PDFInfo.examAssignCount, this.PDFInfo.examUnAssignCount, 'Chart_B_7', '分配统计');
				await this.set_Chart_Pie(this.PDFInfo.reviewCount, this.PDFInfo.unReviewCount, 'Chart_B_8', '评阅统计');
				// 各评阅教师日评阅量统计图
				await this.set_dailyReview_Chart(this.PDFInfo.reviewDateList, this.PDFInfo.isReview, this.PDFInfo.averageReviewCount);
				// 教师阅卷工作量	// 
				await this.set_ChartH(this.PDFInfo.reviewList, this.PDFInfo.isReview);
				// 主观题得分
				if (!this.PDFInfo.reviewScoreList) this.PDFInfo.reviewScoreList = [];
				this.PDFInfo.reviewScoreList.map((e, i)=>{ this.set_ChartI(e, this.PDFInfo.isReview, i) })
				// 是否显示主观题得分情况
				this.isHasMedian = false;
				this.PDFInfo.reviewScoreList.map(e=>{
					if (e.scoreMedian) {
						this.isHasMedian = true;
					}
				});

				// 成绩正态分布图
				this.PDFInfo.analysInfo.map((e, i)=>{ this.set_ChartJ(e, i) });

				// 修改网页title
				this.PDF_title = tenantName + '_' + this.PDFInfo.planName + '_' + this.PDFInfo.timestamp.slice(0, 13);
				document.title = this.PDF_title;
			},

			/**
			 * @param { 地图散点图 }
			 */
			set_ChartA(val){
					var dataValue = val ? val : [];
					var chartDom = document.getElementById("Chart_A")
					var myChart = this.$echarts.init(chartDom)
					let option = {
							tooltip: {
								show: false
							},
							geo: {
								map: "china",
								roam: false,
								zoom: 1.23,
								center: [105, 36],
								label: {
									normal: {
									show: false,
									fontSize: "10",
									color: "#FFF"
									},
									emphasis: {
											show: false
									}
								},
							},
							series: [
								{
									type: "map",
									map: "china",
									roam: false,
									zoom: 1.23,
									center: [105, 36],
									showLegendSymbol: false,
									label: {
										normal: {
											show: false
										},
										emphasis: {
											show: false,
											textStyle: {
												color: "#FFF"
											}
										}
									},
									itemStyle: {
										normal: {
											areaColor: "#FFF",
											borderColor: "#ccc",
											borderWidth: 0.5
										},
										emphasis: {
											areaColor: "#FFF",
											shadowOffsetX: 0,
											shadowOffsetY: 0,
											shadowBlur: 5,
											borderWidth: 0,
											shadowColor: "rgba(0, 0, 0, 0.5)"
										}
									}
								},
								{
									name: "",
									type: "effectScatter",
									coordinateSystem: "geo",
									data: dataValue,
									symbolSize: 10,
									tooltip: {
										show: false
									},
									encode: {
										value: 2
									},
									showEffectOn: "render",
									rippleEffect: {
										brushType: "stroke",
										color: "#006AFF",
										period: 9,
										scale: 5
									},
									hoverAnimation: true,
									label: {
										formatter: "{b}",
										position: "right",
										show: true
									},
									itemStyle: {
										color: "#006AFF",
										shadowBlur: 2,
										shadowColor: "#333"
									},
									zlevel: 1
								}
							]
					};
					option && myChart.setOption(option)
			},

			/**
			 * @param { 饼状图 }
			 * @v1 { 值1 }
			 * @v2 { 值2 }
			 * @key { E-charts ID }
			 * @label { 图形描述 }
			 */
			set_Chart_Pie(v1, v2, key, label) {
				// 是否展示导线
				let isShowLine = true;
				// 是否环状图
				let isRadius = false;
				// 需要多色的饼图 key
				let keys = ['Chart_B_1', 'Chart_B_4', 'Chart_B_5']
				// 环形图
				let keys_p = ['Chart_B_7', 'Chart_B_8']
				// 色组
				var colorList = [
					{c1: '#1CCBAF', c2: '#14B8D8'}, 	// 0
					{c1: '#FFB588', c2: '#FA7922'},		// 1
					{c1: '#EEEEEE', c2: '#ECECEC'},		// 2
					{c1: '#5DC9FF', c2: '#0077FF'},		// 3
					{c1: '#05C985', c2: '#00B375'},		// 4
					{c1: '#FFA63E', c2: '#FF7D27'}		// 5
				]
				// 配置色组
				if (keys.includes(key)) {
					colorList = [colorList[0], colorList[1]];
				} else if (key == 'Chart_B_6') {
					colorList = [colorList[3], colorList[1]];
				} else if (keys_p.includes(key)) {
					// 环形图 => 不要导线 => 开启环形图配置
					isShowLine = false;
					isRadius = true;
					colorList = [colorList[4], colorList[5]];
				} else {
					colorList = [colorList[0], colorList[2]];
				}
      	let myChart = this.$echarts.init(document.getElementById(key))
				var option = {
					legend: {
						top: '5%',
						left: 'center'
					},
					series: [
						{
							type: 'pie',
							radius: isRadius ? ['45%', '70%']: ['0%', '80%'],
							label: {
								normal: {
									show: true,
									fontSize: 14,
									position: label ? 'center': 'outside',
									formatter: function(params) {
										if (isShowLine) {
											return params.percent + ' %';
										} else if (label){
											return label
										} else {
											return ''
										}
									}
								},
								fontFamily: 'PingFangSC-Regular, PingFang SC',
							},
							itemStyle: {
								normal: {
									color: function(params) {
										return {
											type: 'linear',
											colorStops: [
												{ offset: 0, color: colorList[params.dataIndex].c1},
												{ offset: 1, color: colorList[params.dataIndex].c2},
											]
										}
									}
								}
							},
							labelLine: {show: isShowLine},
							data: [{ value: v1},{ value: v2}],
						}
					]
      	};

      	option && myChart.setOption(option);
			},

			/**
			 * @param { 报名人数分布图 }
			 */
			set_Chart_Sign(list) {
				let x_Data = []
				let y_Data = []
				list.map(e=>{
					e.title = e.title.slice(5).replace('-', '/')
					x_Data.push(e.title)
					y_Data.push(e.number)
				})
      	let myChart = this.$echarts.init(document.getElementById("Chart_Sign"))
				var option = {
					grid: {
						x: 60,
						x2: 48,
						y2: 36,
					},
					xAxis: {
						type: 'category',
						data: x_Data,
					},
					yAxis: {
						name: "单位：人",
						nameTextStyle: {
							color: '#9299A6',
							fontFamily: 'PingFangSC-Regular, PingFang SC',
							nameLocation: 'start'
						},
						splitNumber: 4,
						type: 'value',
					}, 
					series: [
						{
							data: y_Data,
							type: 'line',
							smooth: false,
							itemStyle: {
								normal: {
									color: '#1E90FF',
									borderColor: '#1E90FF',
									borderWidth: 2,
									label: {
										show: true,
										position: 'top',
										textStyle: {
											color: "#45494d",
											fontSize: 12
										}
									}
								},
								
							},
							areaStyle: {
								normal: {
									color: {
										type: 'linear',
										x: 0,
										y: 0,
										x2: 0,
										y2: 1,
										colorStops: [
											{ offset: 0, color: 'rgba(38, 91, 255, 0.35)'},
											{ offset: 1, color: 'rgba(38, 91, 255, 0)'}
										],
										global: false
									}
								}
							}
						},
					]
      	}
	      option && myChart.setOption(option)
			},

			/** 
			 * @param { 考生签到情况统计图 }
			 */
			set_ChartE(list, flag) {

				if(!flag) return false;

				this.$nextTick(()=>{
					let colorList = [
						{c1: '#05C985', c2: '#00B375'},
						{c1: '#056CFF', c2: '#023AFF'},
						{c1: '#FFA63E', c2: '#FF7D27'},
						{c1: '#FF5C26', c2: '#FF794D'},
					]
					let y_Data = []
					let x_Data = 
						flag == 1 ? 
							[{name: '签到通过', color: '#00B375'},{name: '未签到', color: '#023AFF'},{name: '签到不通过', color: '#FF7D27'},{name: '强制交卷', color: '#FF794D'}]
						: 
							[{name: '强制交卷', color: '#FF794D'}]
					;
					x_Data.map((e, i)=>{
						e.type = 'bar';
						e.barWidth = 12;
						e.barMaxWidth = 36;
						e.barMinHeight = 4;
						e.data = [];
						e.barBorderRadius = 2;
						e.position = [0, 0, 0, 6]
						e.itemStyle = {
							normal: {
								barBorderRadius: 2,
								color: function(params) {
									return {
										type: 'linear',
										colorStops: [
											{ offset: 0, color: colorList[i].c1},
											{ offset: 1, color: colorList[i].c2},
										]
									}
								}
							}
						}
					})
					list.map(e=>{
						y_Data.push(e.placeName)
						x_Data[3].data.push(e.forceSubmitCount)
						if (flag == 1) {
							x_Data[0].data.push(e.signPassCount)
							x_Data[1].data.push(e.unSignCount)
							x_Data[2].data.push(e.signUnPassCount)
						}
					})
					let myChart = this.$echarts.init(document.getElementById("Chart_E"))
					var option = {
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'shadow'
							}
						},
						legend: {},
						grid: {
							left: '3%',
							right: '4%',
							bottom: '3%',
							containLabel: true
						},
						xAxis: {
							type: 'value',
						},
						yAxis: {
							type: 'category',
							data: y_Data
						},
						series: x_Data
					};
					option && myChart.setOption(option);
				})
			},

			/**
			 * @param { 并发统计图 }
			 */
			set_Concurrency(list) {
				let myChart = this.$echarts.init(document.getElementById("Concurrency"))
				let data = []
				list.map(e=>{
					let item = {
						product: e.timeStr,
						login: e.loginNumber,
						submit: e.submitNumber
					}
					data.push(item)
				})	
				var option = {
					grid: {x: 60, x2: 12, y2: 64},
					legend: {},
					tooltip: {},
					dataset: {
						dimensions: ['product', 'login', 'submit'],
						source: data
					},
					xAxis: { 
						type: 'category',
						axisLabel: {
							interval: 0,
							margin: 16,
            	padding: [0, 0 , 0, -16],
							rotate: 30,
						},
					},
					yAxis: {
						name: '单位：人次'
					},
					series: [
						{ 
							name: "进场数",
							type: 'bar', 
							barMaxWidth: 36,
							barWidth: 20,
							color: '#00A66F',
							itemStyle: {
								normal: {
									color: '#05C985',
									barBorderRadius: [2, 2, 0, 0],
									label: {
										show: true,
										position: 'top',
										textStyle: {
											color: "#9299A6",
											fontSize: 12
										},
										formatter: function (params) {
											if (params.value.login == 0) {
												return ''
											}
										}
									},
									color: function(params) {
										return {
											x: 0,
											y: 0,
											x2: 0,
											y2: 1,
											colorStops: [
												{ offset: 0, color: '#00D48A'},
												{ offset: 1, color: '#00A66F'},
											]
										}
									}
								}
							},
						},
						{ 
							name: "交卷数",
							type: 'bar',
							color: '#FF7D27',
							barMaxWidth: 36,
							barWidth: 20,
							itemStyle: {
								normal: {
									color: '#FFA63E',
									barBorderRadius: [2, 2, 0, 0],
									label: {
										show: true,
										position: 'top',
										textStyle: {
											color: "#9299A6",
											fontSize: 12
										},
										formatter: function (params) {
											if (params.value.submit == 0) {
												return ''
											}
										},
									},
									
									color: function(params) {
										return {
											x: 0,
											y: 0,
											x2: 0,
											y2: 1,
											colorStops: [
												{ offset: 0, color: '#FFA63E'},
												{ offset: 1, color: '#FF7D27'},
											]
										}
									}
								}
							},
						}
					],
				};

				option && myChart.setOption(option);
			},

			/**
			 * @param { 并发统计 单科 }
			 */
			set_Concurrency_line(list) {
				let x_Data = []
				let y_Data_1 = []
				let y_Data_2 = []
				list.map(e=>{
					x_Data.push(e.timeStr)
					y_Data_1.push(e.loginNumber)
					y_Data_2.push(e.submitNumber)
				})

      	let myChart = this.$echarts.init(document.getElementById("Concurrency_line"))
				var option = {
					legend: {},
					tooltip: {},
					grid: {
						x: 60,
						x2: 48,
						y2: 36,
					},
					xAxis: {
						type: 'category',
						data: x_Data
					},
					yAxis: {
						name: "单位：人次/分钟",
						nameTextStyle: {
							color: '#9299A6',
							fontFamily: 'PingFangSC-Regular, PingFang SC',
							nameLocation: 'start'
						},
						splitNumber: 4,
						type: 'value',
					},
					series: [
						{
							name: "进场人数",
							data: y_Data_1,
							type: 'line',
							smooth: false,
							itemStyle: {
								normal: {
									color: '#05C985',
									borderColor: '#05C985',
									borderWidth: 2,
									// label: {
									// 	show: true,
									// 	position: 'top',
									// 	textStyle: {
									// 		color: "#45494d",
									// 		fontSize: 12
									// 	}
									// }
								},
							},
						},
						{
							name: "交卷人数",
							data: y_Data_2,
							type: 'line',
							smooth: false,
							itemStyle: {
								normal: {
									color: '#FF842B',
									borderColor: '#FF842B',
									borderWidth: 2,
									// label: {
									// 	show: true,
									// 	position: 'top',
									// 	textStyle: {
									// 		color: "#45494d",
									// 		fontSize: 12
									// 	}
									// }
								},
							},
						},
					]
      	}
	      option && myChart.setOption(option)
			},

			/**
			 * @param { 阅卷教师日评阅量统计 }
			 */
			set_dailyReview_Chart(list, flag, markDate) {
				// 不显示"阅卷模块"不绘制
				if (flag != 1) return
				// 配置色组(c1: 浅色)
				let colorList = [
					{c1: '#FF3725', c2: '#D91200'},	// 1
					{c1: '#FFA97E', c2: '#FF6A00'},	// 2
					{c1: '#FFDC73', c2: '#FF9A0D'}, // 3
					{c1: '#B0DF2D', c2: '#79C100'}, // 4
					{c1: '#00D48A', c2: '#00A66F'}, // 5
					{c1: '#00D9D2', c2: '#00B9DE'}, // 6
					{c1: '#3081F2', c2: '#0060E6'}, // 7
					{c1: '#968CFF', c2: '#5736FF'}, // 8
					{c1: '#D659FF', c2: '#AF0BE6'}, // 9
					{c1: '#F255B1', c2: '#CC0077'}, // 10
					{c1: '#E53722', c2: '#991200'}, // 11
					{c1: '#E2733B', c2: '#8C3A00'}, // 12
					{c1: '#FFCF40', c2: '#BF6913'}, // 13
					{c1: '#8FB621', c2: '#557A18'}, // 14
					{c1: '#19A677', c2: '#106649'}, // 15
					{c1: '#00B2C2', c2: '#088199'}, // 16
					{c1: '#2E7AE6', c2: '#003A8C'}, // 17
					{c1: '#6759FF', c2: '#2407BE'}, // 18
					{c1: '#B032DA', c2: '#5A0078'}, // 19
					{c1: '#D93695', c2: '#99004D'}, // 20
				]
      	let myChart = this.$echarts.init(document.getElementById("Chart_G"))
				let data = []
				let barList = []
				let dimensions = ['product']
				list.map(e=>{
					let item = {}
					item.product = e.dateStr.slice(5).replace('-', '/')
					e.teacherInfo.map(val=>{
						item[val.title] = val.number
					})
					data.push(item)
				})
				list[0].teacherInfo.map((e, i)=>{
					barList.push({ 
						color: colorList[i].c2,
						type: 'bar', 
						barMinHeight: 4,
						barMaxWidth: 12,
						// barWidth: 12,
						itemStyle: {
							barBorderRadius: 2,
							normal: {
								// label: {
								// 	show: true,
								// 	position: 'top',
								// 	textStyle: {
								// 		color: "#9299A6",
								// 		fontSize: 12
								// 	}
								// },
								color: function(params) {
									return {
										x: 0,
										y: 0,
										x2: 0,
										y2: 1,
										colorStops: [
											{ offset: 0, color: colorList[i].c1},
											{ offset: 1, color: colorList[i].c2},
										]
									}
								}
							}
						},
						markLine: {
							tooltip: { show: false },
							symbol: 'none',
							label: {
									formatter: ()=>{
										return `日均阅卷\n${markDate} 份`;
									},
									color: "#006aff",
									fontSize: 12,
									fontWeight: 400,
									fontFamily: "PingFangSC-Regular, PingFang SC",
									lineHeight: 17,
							},
							lineStyle: {
								color: "#006aff",
							},
							data: [{
								yAxis: markDate,
								silent: true,
							}]
						}
					})
					dimensions.push(e.title)
				})
				var option = {
					grid: {
						x: 60,
						x2: 64,
						y2: 36,
						y: 80,
					},
					legend: {
						x: "center",
						y: "top",
					},
					tooltip: {},
					dataset: {
						dimensions: dimensions,
						source: data
					},
					xAxis: { type: 'category' },
					yAxis: {
						name: "单位：份"
					},
					series: barList,
				};
				option && myChart.setOption(option);
			},

			/**
			 * @param { 阅卷教师评阅工作量 }
			 */
			set_ChartH(list, flag) {
				if (flag != 1) return
      	let myChart = this.$echarts.init(document.getElementById("Chart_H"))
				let data = []
				list.map(e=>{
					let item = {
						product: e.teacherName,
						'已评阅': e.reviewCount,
						'待评阅': e.unReviewCount
					}
					data.push(item)
				})
				var option = {
					grid: {x: 60, x2: 48, y2: 36},
					legend: {},
					tooltip: {},
					dataset: {
						dimensions: ['product', '已评阅', '待评阅'],
						source: data
					},
					xAxis: {
						type: 'category',
						axisLabel: {
							interval: 0
						}
					},
					yAxis: {
						name: '单位：份',
					},
					series: [
						{ 
							type: 'bar', 
							barMaxWidth: 36,
							barMinHeight: 1,
							barWidth: 12,
							color: '#00A66F',
							itemStyle: {
								normal: {
									color: '#05C985',
									barBorderRadius: [2, 2, 0, 0],
									label: {
										show: true,
										position: 'top',
										textStyle: {
											color: "#9299A6",
											fontSize: 12
										}
									},
									color: function(params) {
										return {
											x: 0,
											y: 0,
											x2: 0,
											y2: 1,
											colorStops: [
												{ offset: 0, color: '#00D48A'},
												{ offset: 1, color: '#00A66F'},
											]
										}
									}
								}
							},
						},
						{ 
							type: 'bar',
							color: '#FF7D27',
							barMaxWidth: 36,
							barWidth: 12,
							barMinHeight: 1,
							itemStyle: {
								normal: {
									color: '#FFA63E',
									barBorderRadius: [2, 2, 0, 0],
									label: {
										show: true,
										position: 'top',
										textStyle: {
											color: "#9299A6",
											fontSize: 12
										}
									},
									color: function(params) {
										return {
											x: 0,
											y: 0,
											x2: 0,
											y2: 1,
											colorStops: [
												{ offset: 0, color: '#FFA63E'},
												{ offset: 1, color: '#FF7D27'},
											]
										}
									}
								}
							},
						}
					],
				};

				option && myChart.setOption(option);
			},

			/**
			 * @param { 阅卷教师评分情况 }
			 */
			set_ChartI(list, flag, i) {
				if (flag != 1) return;
				if (list.teacherInfo.length == 0) return
				this.$nextTick(()=>{
					let x_Data = []
					let y_Data = []
					list.teacherInfo.map(e=>{
						x_Data.push(e.title)
						y_Data.push(e.number)
					})

					let myChart = this.$echarts.init(document.getElementById(`Chart_I${i}`))
					var option = {
						grid: {x: 60, x2: 48, y2: 36},
						xAxis: {
							type: 'category',
							data: x_Data
						},
						yAxis: {
							type: 'value',
							name: '主观题均分',
						},
						series: [
							{
								data: y_Data,
								type: 'bar',
								barWidth: 16,
								barMaxWidth: 36,
								itemStyle: {
									normal: {
										color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
											{ offset: 0, color: "#5DC9FF" },
											{ offset: 1, color: "#0077FF" },
										]),
										label: {
											show: true,
											position: 'top',
											textStyle: {
												color: "#9299A6",
												fontSize: 12
											}
										}
									},
								},
								markLine: {
									data: [{ 
										yAxis: list.scoreMedian,
										silent: true,
										label: {
											formatter: ()=>{
												return `中位数\n${list.scoreMedian} 分`;
											},
											color: "#006aff",
											fontSize: 12,
											fontWeight: 400,
											fontFamily: "PingFangSC-Regular, PingFang SC",
											lineHeight: 17,
									},
									}]
								}
							}
						]
					};
					option && myChart.setOption(option);
				})
			},

			/**
			 * @param { 正态分布图 }
			 */
			set_ChartJ(list, i) {
				this.$nextTick(()=>{
					let myChart = this.$echarts.init(document.getElementById(`Chart_J${i}`));
					let option = {};
					let xAxisData = list.scoreSection.map((item) => item.maxScore);
					let dataInfo = list.scoreSection.map((item) => item.sectionNameCount);
					let lineData = list.scoreSection.map((item) => item.sectionNameNormal);
					let maxCount = Math.max.call(...dataInfo);
					let maxNormal = Math.max.call(...lineData);
					option = {
						title: {
							text: '科目：' + list.courseName,
							textStyle: {
								fontSize: 13,
								color: '#737780',
								fontWeight: 500,
							},
							subtext: `单位：人`,
						},
						legend: {
							x: 'center',
							y: 'bottom',
							padding: [80, 0, 0 , 0]
						},
						color: ["#3398DB"],
						tooltip: {
							trigger: "axis",
							axisPointer: {
								type: "line",
							},
						},
						grid: {
							left: "3%",
							right: "4%",
							bottom: "8%",
							containLabel: true,
						},
						xAxis: [
							{
								type: "category",
								data: xAxisData,
								axisTick: {
									alignWithLabel: true,
								},
								axisLine: {
									onZero: false,
									lineStyle: {
										color: "#4b87a9",
									},
								},
							},
						],
						yAxis: [
							{
								type: "value",
								min: 0,
								max: maxCount + 10,
								position: "left",
								splitLine: {
									show: false,
								},
								axisLine: {
									onZero: false,
									lineStyle: {
										color: "#4b87a9",
									},
								},
							},
							{
								type: "value",
								position: "right",
								name: "",
								min: 0,
								max: (maxNormal * 1.2).toFixed(6),
								interval: (maxNormal * 1.2).toFixed(5) / 5,
								axisLabel: {
									formatter: "{value}",
								},
							},
						],
						series: [
							{
								name: "段内人数",
								type: "bar",
								barWidth: "18%",
								data: dataInfo,
								itemStyle: {
									normal: {
										color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
											{ offset: 0, color: "#5DC9FF" },
											{ offset: 1, color: "#0077FF" },
										]),
									},
								},
							},
							{
								name: "正态分布值",
								type: "line",
								data: lineData,
								yAxisIndex: 1,
								smooth: true,
								symbol: "emptyCircle",
								symbolSize: 8,
								itemStyle: {
									normal: {
										color: "#006AFF",
										borderColor: "#006AFF",
										borderWidth: 2,
									},
								},
							},
						],
					};
					option && myChart.setOption(option);
				})
			},
		
			/**
			 * @param { 导出分析报告 }
			 */
			handleExportPdf() {
				// 滚动到顶部，确保打印内容完整
				document.body.scrollTop = 0; // IE的
				document.documentElement.scrollTop = 0; // 其他
				let that = this
				this.$message.success("正在导出，请稍作等待。")
				this.timer2 = setTimeout(() => {
					that.htmlToPdf("pdfDom", this.PDF_title,function() {
				});
				}, 1000);
			}		      
    },
  }
</script>

<style scoped lang="less">
// 大标题
.viewReportBox_Title {
	box-sizing: border-box;
	// padding: 32px 0 15px;
	padding-top: 32px;
	.viewReportTit {
		span {
			color: #2D2F33;
			font-size: 24px;
			font-weight: 600;
			font-family: 'PingFangSC-Regular, PingFang SC';
		}
		.title_Left {
			width: 6px;
			height: 14px;
			display: inline-block;
			margin-right: 6px;
			border-radius: 1px 3px 1px 1px;
			background: linear-gradient(#5DC9FF, #0077FF);
		}
	}
}

// 二级标题
.viewReportTit_2 {
	padding: 0 30px;
	span {
		font-size: 20px;
		font-weight: 600;
		font-family: 'PingFangSC-Regular, PingFang SC';
		line-height: 24px;
		color: #2E3033;
	}
}

// 大背景
.viewReportBox {
	background-color: #ffffff;
	border-radius: 6px;
	margin-top: 20px;
	padding-top: 20px;
	padding-bottom: 24px;
}

// 公共
.viewReportMa {
	padding: 0 30px 24px 30px;
	font-family: 'PingFangSC-Regular, PingFang SC';
	.countBox {
		display: flex;
		margin-top: 40px;
		.title {
			width: 100px;
			font-size: 14px;
			color: #2D2F33;
			font-weight: 600;
			line-height: 24px;
		}
		.content {
			width: 938px;
			color: #45494D;
			font-size: 16px;
			line-height: 24px;
			.content_time {
				font-weight: 400;
				margin-top: 16px;
				p {
					span {
						margin-right: 36px;
					}
					span:nth-child(3){
						margin-right:0;
					}
				}
			}
		}
	}
}

// 阅卷
.Grading_papers {
	margin-left: 60px;
	.Chart_B_Border {
		justify-content: space-around; 
		margin-top: 0;
		.item {
			width: 480px; 
			height: 270px; 
			display: flex; 
			justify-content: space-between;
			.chart {
				width: 270px; 
				height: 270px; 
				border-right: none;
			}
			.desc {
				flex-wrap: wrap; 
				margin-left: 24px; 
				width: 180px;
				&>div {
					width: 100%; 
					margin-top: 24px;
				}
				&>div:first-child {
					width: 100%; 
					margin-top: 96px;
				}
			}
		}
	}
}

// Bar 类标题
.viewReportBar {
	font-family: 'PingFangSC-Regular, PingFang SC';
	height: 50px;
	margin: 0 auto;
	margin-bottom: 20px;
	margin-top: 28px;
	display: flex;
	justify-content: space-around;
	.Bar_item {
		min-width: 100px;
		width: auto;
		height: 50px;
		font-weight: 400;
		font-size: 16px;
		text-align: center;
		color: #737780;
		p:first-child {
			height: 32px;
			line-height: 32px;
		}
		p {
			strong {
				font-size: 18px;
				color: #2D2F33;
				margin-right: 2px;
			}
		}
	}
}

// 水印
.waterView {
	width: 1270px;
	height: calc(100% - 200px);
	position: absolute;
	top: 200px;
	pointer-events: none;
	.waterItem {
		width: 420px;
		height: 420px;
		float: left;
		background: 000;
		p {
			font-size: 16px;
			margin-top: 45%;
			text-align: center;
			color:#9299A6;
			opacity: .2;
			transform: rotate(-45deg);
		}
	}
}


.Concurrency {
	font-size: 16px;
	font-weight: 400;
	text-align: center;
	margin-top: 24px;
}

[v-clock] {
	display: none;
}

	.Chart_A_Box {
		display: flex;
		.Chart_A {
			width: 100%;
			height: 560px;
			background:#fff
		}
		.rateCenterText {
			position:absolute;
			width: 40%;
			right: 0;
			bottom: 0;
			text-align: center;
			span {
				display: block;
				padding-top: 5px;
				font-size: 18px;
				color: #2E3033;	
				font-weight: bold;		
			}
		}
	}
	
	.Chart_B_Border {
		font-family: 'PingFangSC-Regular, PingFang SC';
		width: 100%;
		height: 264px;
		margin-top: 61px;
		display: flex;
		justify-content: space-around;
		.item {
			width: 336px;
			height: 264px;
			.title {
				height: 22px;
				font-size: 18px;
				color: #45494D;
				margin-bottom: 16px;
				margin-left: 24px;
				font-weight: 500;
			}
			.chart {
				width: 380px;
				height: 220px;
			}
			.chart:first-child {
				border: none;
			}
			.desc {
				width: auto;
				height: 18px;
				display: flex;
				justify-content: space-around;
				color: #737780;
				font-size: 16px;
				font-weight: 400;
				border: 1px solid transparent;
				margin-top: 8px;
				&>div {
					.icon {
						display: inline-block;
						width: 12px;
						height: 12px;
						border-radius: 2px;
						background: linear-gradient(180deg, #1BC9B2 0%, #17BDCE 100%);
						margin-right: 6px;
					}
				}
			}
		}
	}

	.Chart_C_Border {
		font-family:'PingFangSC-Regular, PingFang SC';
		width: 60%;
		height: 330px;
		margin: 24px auto 0;
		display: flex;
		flex-wrap: wrap;
		.Chart_C {
			width: 300px;
			height: 300px;
		}
		.desc {
			width: 210px;
			height: 300px;
			.A,.B {
				width: 100%;
				display: flex;
				align-items: center;
				&>div:first-child {
					width: 16px;
					height: 16px;
					margin-right: 4px;
				}
			}
			.A {
				margin-top: 45%;
				margin-bottom: 5%;
			}						
		}
		.bottom {
			width: 100%;
			text-align: center;
			span {
				display: block;
				padding-top: 5px;
				font-size: 18px;
				color: #2E3033;	
				font-weight: bold;		
			}
		}
	}

	.Chart_E_Border {
		font-family:'PingFangSC-Regular, PingFang SC';
		width: 100%;
		height: 680px;
		margin-top: 24px;
		.Chart_E {
			width: 100%;
			height: 650px;
		}
		.bottom {
			width: 100%;
			text-align: center;
			span {
				display: block;
				padding-top: 5px;
				font-size: 18px;
				color: #2E3033;	
				font-weight: bold;		
			}
		}
	}

	.Chart_F_Border {
		font-family:'PingFangSC-Regular, PingFang SC';
		width: 100%;
		height: 360px;
		margin-top: 24px;
		.Chart_F {
			width: 100%;
			height: 330px;
			display: flex;
			.Chart_F_Left,.Chart_F_Right {
				width: 50%;
				height: 280px;
				&>div:first-child {
					width: 515px;
					height: 280px;
				}
				.desc {
					height: 50px;
					&>div {
						width: 100%;
						height: 24px;
						display: flex;
						align-items: center;
						.dit {
							width: 16px;
							height: 16px;
							border-radius: 4px;
							margin-right: 8px;
							margin-left: 35%;
							background: red;
						}
					}
				}
			}

			.Chart_F_Right .desc div .dit {
				margin-left: 40%;
			}
		}
		.bottom {
			text-align: center;
			span {
				display: block;
				padding-top: 5px;
				font-size: 18px;
				color: #2E3033;	
				font-weight: bold;		
			}
		}
	}

	.Chart_G_Box {
		font-family: 'PingFangSC-Regular, PingFang SC';
		width: 100%;
		height: auto;
		margin-top: 24px;
		.Chart_G {
			width: 1033px;
			height: 480px;
		}
		.bottom {
			text-align: center;
			span {
				display: block;
				padding-top: 5px;
				font-size: 18px;
				color: #2E3033;	
				font-weight: bold;		
			}
		}
	}

	.table_A {
		font-family: 'PingFangSC-Regular, PingFang SC';
		width: 100%;
		height: auto;
		.bottom {
			margin-top: 24px;
			text-align: center;
			span {
				display: block;
				padding-top: 5px;
				font-size: 18px;
				color: #2E3033;	
				font-weight: bold;		
			}
		}
	}

	.Chart_J {
		margin-bottom: 24px;
		border-bottom: 1px dashed #CCC;
		font-family: 'PingFangSC-Regular, PingFang SC';
	}

  .report-export {
		display: flex;
		flex-direction: column;
		align-items: center;
  }

  .reportExportMain {
    width: 1270px;
    position: relative;
  }

  .reportExportDom {
    background:#F4F5F8 no-repeat center top;
    position: relative;
		.setBackground {
			width: 100vw;
			height: 320px;
			position: absolute;
			left: calc(0px - ((100vw - 100%) / 2));
		  background-size: 100% auto;
		}
  }

  .reportExportBox {
    width: 1093px;
    margin: 0 auto;
		position: relative;
  }

	.reportExport {
		color: #3389FF;
		font-size: 16px;
		font-family: 'PingFangSC-Regular, PingFang SC';
		padding-left: 25px;
		cursor: pointer;
		line-height: 32px;
	}






	.chartItem{
		width:100%;
		height:280px;
		background:#fff
	}	

	.excellentRateText strong {
		color: #43BFAB;
	}

	.barBox {
		background: #F2F6FC;
		height: 20px;
		line-height: 20px;
		margin-left: 100px;
		position: relative;
	}

	.bar {
		position: absolute;
		left: 0;
		top: 0;
		height: 20px;
		text-align: right;
		span {			
			color: #666666;
			font-size: 12px;
			padding: 0 10px;
			white-space: nowrap;
		}
		.haveDa {
			color: #ffffff;
		}
	}

	.scoreNormalDistributionBox {
		position: relative;
		.chartItem {
			height: 380px;
		}
	}

	.coefficientBox {
		position:absolute;
		right: 70px;
		top: 0;
		color: #2D2F33;
		span {
			display: inline-block;
			margin-left: 35px;
			strong {
				color: #3389FF;
			}
		}
	}

	// LOGO + TITLE
  .reportTitle {
		height: 320px;
		border: 1px solid transparent;
		font-family: 'PingFangSC-Regular, PingFang SC';
		position: relative;
		.LOGO {
			margin-top: 40px; 
			margin-left: 24px;
			height: 40px;
			// width: 180px;
			width: auto;
			margin-right: 24px;
			padding-right: 16px;
			background: no-repeat left center;
			background-size: auto 40px;			
			border-right: 1px solid #ccc;
			img {
				height: 40px;
				width: auto;
			}
		}
		.analysisScope {
			margin-top: 72px;
			text-align: center;
			font-size: 48px;
			color: #FFF;
		}
		.ImgCode {
			position: absolute;
			width: 92px;
			height: 92px;
			background: no-repeat left center;
			background-size: 92px 92px;			
			top: 40px;
			right: 40px;
		}
  }	

  .reportFooter {
    background: #FFFFFF;
    padding: 30px 0;
    text-align: center;
    margin-top: 50px;
  }

  .reportCanvas {
    position: absolute;
    width: 100%;
    left: 0;
    top: 350px;
		height: 50px;
		background:#F4F5F8;
  }

  .reportOpt {
		position: absolute;
		width: 100%;
		left: 0;
		top: 0;	
  }

  .reportOptMa {
		width: 1093px;
    margin: 0 auto;
		position: relative;	
  }


  .reportExportOpt {
		position: absolute;
		right: 30px;
		top: 350px;
  }
</style>
